import Slider from "react-slick"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../App.css"


export const CarouselSlider = () => {
  const settings = {
    // dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    fade: true,
    cssEase: "ease-in-out",
    pauseOnHover: true,
    customPaging: (i) => (
      <div style={{
        width: '12px',
        height: '12px',
        borderRadius: '50%',
        background: 'rgba(255, 255, 255, 0.5)',
        border: '2px solid rgba(255, 255, 255, 0.8)',
        cursor: 'pointer',
        transition: 'all 0.3s ease'
      }} />
    ),
  }

  const slideStyle = {
    position: 'relative',
    // height: 'calc(100vh - 80px)',
    // minHeight: '500px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    overflow: 'hidden',
    marginTop: '80px'
  }

  const overlayStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.4) 100%)',
    zIndex: 1
  }

  const contentStyle = {
    position: 'relative',
    zIndex: 2,
    textAlign: 'center',
    color: 'white',
    maxWidth: '800px',
    padding: '40px 20px',
    background: 'rgba(0, 0, 0, 0.3)',
    borderRadius: '20px',
    backdropFilter: 'blur(10px)',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    boxShadow: '0 20px 40px rgba(0, 0, 0, 0.3)',
    height: '500px',
    margin: 'auto'
  }

  const titleStyle = {
    fontSize: 'clamp(2rem, 5vw, 3.5rem)',
    fontWeight: 'bold',
    marginBottom: '20px',
    textShadow: '2px 2px 4px rgba(0, 0, 0, 0.8)',
    lineHeight: '1.2'
  }

  const subtitleStyle = {
    fontSize: 'clamp(1.2rem, 3vw, 2rem)',
    marginBottom: '30px',
    opacity: 0.9,
    textShadow: '1px 1px 2px rgba(0, 0, 0, 0.8)'
  }

  const paragraphStyle = {
    fontSize: 'clamp(1rem, 2.5vw, 1.3rem)',
    lineHeight: '1.6',
    marginBottom: '30px',
    opacity: 0.9
  }

  const linkStyle = {
    color: '#4F46E5',
    textDecoration: 'none',
    fontWeight: 'bold',
    padding: '8px 16px',
    background: 'rgba(79, 70, 229, 0.2)',
    borderRadius: '8px',
    border: '1px solid rgba(79, 70, 229, 0.3)',
    transition: 'all 0.3s ease',
    display: 'inline-block',
    margin: '0 8px'
  }

  const buttonStyle = {
    background: 'linear-gradient(135deg, #4F46E5 0%, #7C3AED 100%)',
    color: 'white',
    border: 'none',
    padding: '16px 32px',
    borderRadius: '12px',
    fontSize: '1.1rem',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    boxShadow: '0 8px 25px rgba(79, 70, 229, 0.4)',
    textDecoration: 'none',
    display: 'inline-block'
  }

  const listStyle = {
    textAlign: 'left',
    maxWidth: '600px',
    margin: '0 auto 30px',
    padding: '0 20px'
  }

  const listItemStyle = {
    fontSize: '1.1rem',
    marginBottom: '12px',
    padding: '8px 0',
    borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
    position: 'relative',
    paddingLeft: '30px'
  }

  return (
    <>
      <style>
        {`
          .slick-dots {
            bottom: 30px !important;
            z-index: 10;
          }
          .slick-dots li.slick-active div {
            background: #4F46E5 !important;
            border-color: #4F46E5 !important;
            transform: scale(1.2);
          }
          .slick-dots li div:hover {
            background: rgba(79, 70, 229, 0.7) !important;
            transform: scale(1.1);
          }
          .slick-prev, .slick-next {
            z-index: 10;
            width: 50px;
            height: 50px;
          }
          .slick-prev:before, .slick-next:before {
            font-size: 30px;
            color: rgba(255, 255, 255, 0.8);
          }
          .slick-prev:hover:before, .slick-next:hover:before {
            color: #4F46E5;
          }
          
          /* Responsive adjustments for fixed header */
          @media (max-width: 1024px) {
            .carousel-slide {
              height: calc(100vh - 75px) !important;
              // margin-top: 75px !important;
            }
          }
          
          @media (max-width: 768px) {
            // .carousel-slide {
            //   height: calc(100vh - 70px) !important;
            //   margin-top: 70px !important;
            //   min-height: 400px !important;
            // }
            .slick-prev, .slick-next {
              width: 40px !important;
              height: 40px !important;
            }
            .slick-prev:before, .slick-next:before {
              font-size: 24px !important;
            }
            .slick-dots {
              bottom: 20px !important;
            }
          }
          
          @media (max-width: 480px) {
            .carousel-slide {
              height: calc(100vh - 65px) !important;
              // margin-top: 65px !important;
              min-height: 350px !important;
            }
            .slick-prev, .slick-next {
              width: 35px !important;
              height: 35px !important;
            }
            .slick-prev:before, .slick-next:before {
              font-size: 20px !important;
            }
            .slick-dots {
              bottom: 15px !important;
            }
          }
          
          @media (max-width: 360px) {
            .carousel-slide {
              height: calc(100vh - 60px) !important;
              // margin-top: 60px !important;
              min-height: 300px !important;
            }
          }
        `}
      </style>

      <div style={{ width: '100%', margin: '0 auto', overflow: "hidden", position: 'relative', height: "500px", paddingBottom: "50px"}}>
        <Slider {...settings}>
          {/* Slide 3 - Arthur International */}
          <div className="carousel-slide slider3" style={{ ...slideStyle }}>
            <div style={{ ...contentStyle, height: "600px" }}>
              <h1 style={{ ...titleStyle, color: '#FFD700' }}>亚瑟国际机构</h1>
              <h3 style={{ ...titleStyle, color: '#4F46E5' }}>WELCOME TO ARTHUR INTERNATIONAL AGENCY</h3>
              <h2 style={{ ...subtitleStyle, color: '#FFD700' }}>
                <em>Your Gateway to Global Education</em>
              </h2>

            </div>
          </div>

          {/* Slide 1 - Hunan University */}
          <div className="carousel-slide  slider1" style={{ ...slideStyle }}>
            {/* <div style={overlayStyle}></div> */}
            <div
              style={contentStyle}

            >

              <h1 style={{ ...titleStyle, color: '#FFD700' }}>湖南中医药大学</h1>
              <h2 style={subtitleStyle}>JOIN "HUNAN UNIVERSITY OF CHINESE MEDICINE"</h2>
              <div style={{
                width: '100px',
                height: '3px',
                background: 'linear-gradient(90deg, #4F46E5, #7C3AED)',
                margin: '20px auto',
                borderRadius: '2px'
              }}></div>
              <p style={paragraphStyle}>
                GET IT NOW! RIGHT FROM US <br />
                <a
                  href="/apply"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={linkStyle}
                  onMouseEnter={(e) => {
                    e.target.style.background = 'rgba(79, 70, 229, 0.4)';
                    e.target.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = 'rgba(79, 70, 229, 0.2)';
                    e.target.style.transform = 'translateY(0)';
                  }}
                >
                  AAS
                </a> or
                <a
                  href="/AGFA/apply"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={linkStyle}
                  onMouseEnter={(e) => {
                    e.target.style.background = 'rgba(79, 70, 229, 0.4)';
                    e.target.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = 'rgba(79, 70, 229, 0.2)';
                    e.target.style.transform = 'translateY(0)';
                  }}
                >
                  AGFA
                </a>
              </p>
            </div>
          </div>

          {/* Slide 2 - Swahili Message */}
          <div className="carousel-slide slider2" style={{ ...slideStyle }}>
            {/* <div style={overlayStyle}></div> */}
            <div
              style={contentStyle}

            >

              <h1 style={{ ...titleStyle, color: '#FF6B6B' }}>NI RAHISI SANA....</h1>
              <h2 style={subtitleStyle}>
                "Fuata ndoto zako, soma China au India — mustakabali wako unaanza hapa."
              </h2>
              <h3 style={{ ...subtitleStyle, fontStyle: 'italic', color: '#FFD700' }}>
                Follow your dreams, study in China or India — your future starts here
              </h3>
            </div>
          </div>

          {/* Slide 3 - Arthur International */}
          <div className="carousel-slide slider3" style={{ ...slideStyle }}>

            <div
              style={contentStyle}

            >
              <h1 style={{ ...titleStyle, color: '#FFD700' }}>get support on:-</h1>

              <div style={listStyle}>
                <div style={listItemStyle}>
                  <span style={{ position: 'absolute', left: '0', color: '#4F46E5' }}>🎓</span>
                  Scholarship and Admission Support in China and India
                </div>
                <div style={listItemStyle}>
                  <span style={{ position: 'absolute', left: '0', color: '#4F46E5' }}>📋</span>
                  Student Visa Application Assistance
                </div>
                <div style={listItemStyle}>
                  <span style={{ position: 'absolute', left: '0', color: '#4F46E5' }}>🎯</span>
                  University Selection and Career Counseling And more...
                </div>
                {/* <div style={listItemStyle}>
                  <span style={{ position: 'absolute', left: '0', color: '#4F46E5' }}>✈️</span>
                  Travel Preparation and Relocation Advice
                </div>
                <div style={listItemStyle}>
                  <span style={{ position: 'absolute', left: '0', color: '#4F46E5' }}>🗣️</span>
                  Pre-departure Briefing and Language Orientation
                </div> */}
              </div>

              <a
                href="https://wa.me/+8619572907062"
                style={{ ...buttonStyle, background: 'linear-gradient(135deg, #25D366 0%, #128C7E 50%, #075E54 100%)' }}
                target='_blank'
                rel="noopener noreferrer"
                onMouseEnter={(e) => {
                  e.target.style.transform = 'translateY(-3px) scale(1.05)';
                  e.target.style.boxShadow = '0 12px 35px rgba(79, 70, 229, 0.6)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0) scale(1)';
                  e.target.style.boxShadow = '0 8px 25px rgba(79, 70, 229, 0.4)';
                }}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" style={{ marginRight: '6px' }}>
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488" />
                </svg>
                CHAT WITH US
              </a>
            </div>
          </div>

          {/* Slide 4 - Image Slide */}
          <div className="carousel-slide slider6" style={{ ...slideStyle }}>
            
            <div
              style={contentStyle}

            >

              <h1 style={titleStyle}>Discover Your Future</h1>
              <h2 style={subtitleStyle}>World-Class Education Awaits</h2>
              <p style={paragraphStyle}>
                Join thousands of students who have transformed their lives through international education
              </p>
            </div>
          </div>

          {/* Slide 5 - Parul University */}
          <div className="carousel-slide slider5" style={{ ...slideStyle }}>
            {/* <div style={overlayStyle}></div> */}
            <div
              style={contentStyle}

            >

              <h1 style={{ ...titleStyle, color: '#FFD700' }}>परुल विश्वविद्यालय</h1>
              <h2 style={{ ...subtitleStyle, color: '#4F46E5' }}>Study in India</h2>
              <h2 style={subtitleStyle}>JOIN "PARUL UNIVERSITY"</h2>
              <div style={{
                width: '100px',
                height: '3px',
                background: 'linear-gradient(90deg, #4F46E5, #7C3AED)',
                margin: '20px auto',
                borderRadius: '2px'
              }}></div>
              <p style={paragraphStyle}>
                GET IT NOW! RIGHT FROM US <br />
                Just apply through
                <a
                  href="/apply"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={linkStyle}
                  onMouseEnter={(e) => {
                    e.target.style.background = 'rgba(79, 70, 229, 0.4)';
                    e.target.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = 'rgba(79, 70, 229, 0.2)';
                    e.target.style.transform = 'translateY(0)';
                  }}
                >
                  AAS
                </a> or
                <a
                  href="/AGFA/apply"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={linkStyle}
                  onMouseEnter={(e) => {
                    e.target.style.background = 'rgba(79, 70, 229, 0.4)';
                    e.target.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = 'rgba(79, 70, 229, 0.2)';
                    e.target.style.transform = 'translateY(0)';
                  }}
                >
                  AGFA
                </a>
              </p>
            </div>
          </div>
        </Slider>
      </div>
    </>
  )
}